function Area({ id, name, longitude, latitude }) {
  return {
    id,
    name,
    longitude,
    latitude,
  };
}
export default Area;
